import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { LoginService } from '@app/core/services/login/login.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { SignUpService } from '@app/core/services/signUp/signUp.service';
import { SignupComponent } from '../signup/signup.component';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';

@Component({
  selector: 'app-accept-invitation',
  templateUrl: './accept-invitation.component.html',
  styleUrls: ['./accept-invitation.component.css']
})
export class AcceptInvitationComponent implements OnInit {
  email : string = null;
  token: string = null;
  invitation: boolean = false;
  userExist: boolean = false;
  hasCompany: boolean = false;
  permission: string = null
  company: string = null;
  constructor(private signupService: SignUpService, private dialog: MatDialog,private router: Router, private loaderService: LoaderService,
    private notification: NotificationService, private activatedRoute: ActivatedRoute,
    private errorhandlerService: ErrorhandlerService) { }
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['tkn'];
      this.fn_checkToken(this.token);
    });
  }
  
  fn_checkToken(token){
    this.signupService.CheckTokenExpiry(token)
    .subscribe((res: any) => {
      this.loaderService.hide();
      if (res.StatusCode == 200) {
        this.email = res.Data.email;
        this.permission = res.Data.permission;        
        this.company = res.Data.company;
        this.fn_openSignup();
      }
      else if(res.StatusCode == 400){
        this.notification.error(res.Message, 'Error');
      }
      else if(res.StatusCode == 208) {
        this.notification.info(res.Message, 'Information');
        this.router.navigate(['']);
      }
      else {        
        if(res.StatusCode != 202)
          this.notification.error(res.Message, 'Error');

        this.email = res.Data.email;
        this.permission = res.Data.permission;
        this.company = res.Data.company;
        this.userExist = true;
        if(res.Data.hasCompany)
          this.hasCompany = res.Data.hasCompany;
      }
    }, err => {
      this.loaderService.hide();
      this.errorhandlerService.handleError(err);
    });
  }
  fn_openSignup(){
      this.dialog.open(SignupComponent, {
        disableClose: false,
        width: window.innerWidth >= 767 ? '50%' : '80%',
        data: { endUser: false, isInvitation: true, invitedEmail: this.email, permission:this.permission }
      });
  }
  acceptInvitation(){
    this.signupService.AcceptInvitation(this.email)
    .subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.notification.info('Thanks for joining.', 'Information');
        this.router.navigate(['']);
      }
      else {
        this.notification.info(res.Message, 'Information');
      }
      this.loaderService.hide();
    }, err => {
      this.loaderService.hide();
      this.errorhandlerService.handleError(err);
    });
  }
}
